import {AxiosError} from 'axios';
import {POST_COORDINATOR_APPEAL_SELECT_CANDIDATE_LISTING_URL} from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import {useCustomMutation} from '../utils/useCustomMutation';
import {Pageable, PageDataSort} from '../group-special-consideration/usePostGroupSCListing';
import {ApiPathParam} from '../../models/SearchParamSchema';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface CandidateDataContent {
  candidateId: string;
  name: string;
  indexNo: string;
}

export interface SearchCandidateListingData {
  content: CandidateDataContent[];
  pageable: Pageable;
  last: boolean;
  totalElements: number;
  totalPages: number;
  first: boolean;
  numberOfElements: number;
  size: number;
  number: number;
  sort: PageDataSort[];
  empty: boolean;
}

export interface SearchCandidateListingRequest {
  q: string;
  examCode: string;
  apiPathParam: ApiPathParam;
  token: string | null;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (data: SearchCandidateListingData) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const usePostCoordinatorAppealSearchCandidateListing = ({
                                                                 onSuccess,
                                                                 onError,
                                                               }: Input = {}) => {
  const postCoordinatorAppealSearchCandidateListing = async (
      requestData: SearchCandidateListingRequest
  ) => {
    const res = await axiosClient.post<SearchCandidateListingData>(
        POST_COORDINATOR_APPEAL_SELECT_CANDIDATE_LISTING_URL(requestData.apiPathParam),
        {
          q: requestData.q,
          examCode: requestData.examCode,
          token: requestData.token,
        }
    );

    return res.data;
  };

  return useCustomMutation(postCoordinatorAppealSearchCandidateListing, {
    onSuccess,
    onError,
  });
};
